var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pageContent"}},[_c('div',{staticClass:"borderBox",attrs:{"id":"formArea"}},[_c('h1',[_vm._v(" Добро пожаловать!")]),_c('p',[_vm._v("Вы авторизовались как "+_vm._s(_vm.getProfile.displayname))])])])}
var staticRenderFns = []

export { render, staticRenderFns }